import React from 'react';
import { useAsync } from 'react-use';
import { useApi, useRouteRef } from '@backstage/core-plugin-api';
import { catalogApiRef, entityRouteRef } from '@backstage/plugin-catalog-react';
import { ArgusApp } from '@eng-portal/plugin-argus-common';
import {
  InfoCard, Link, StructuredMetadataTable,
} from '@backstage/core-components';
import { parseEntityRef, stringifyEntityRef } from '@backstage/catalog-model';
import { omit } from 'lodash';
import { ArgusAppComponentEntity, getArgusAppComponentID } from '@eng-portal/czi-extensions-common';
import AppsIcon from '@mui/icons-material/Apps';

type AppCardProps = {
  app: ArgusApp
  useUtc?: boolean
};

export function AppCard({ app, useUtc }: AppCardProps): JSX.Element {
  const entityRoute = useRouteRef(entityRouteRef);
  const catalogApi = useApi(catalogApiRef);

  const [associateAppComponent, setAssociatedAppComponent] = React.useState<ArgusAppComponentEntity>();

  useAsync(async () => {
    const account = await catalogApi.getEntityByRef({
      kind: 'Component',
      name: getArgusAppComponentID(app.name),
      namespace: 'default',
    });
    const appEnt = account as ArgusAppComponentEntity;
    setAssociatedAppComponent(appEnt);
  }, [app.name, catalogApi]);

  const metadata: Record<string, any> = {
    ...omit(
      app,
      'update_time',
      'envs',
      'admin_team',
      'reader_team',
    ),
  };

  const cardTitle = "App";

  let appLink: JSX.Element | string = cardTitle;
  if (associateAppComponent) {
    metadata.name = (
      <Link to={entityRoute(parseEntityRef(stringifyEntityRef(associateAppComponent)))}>
        {metadata.name}
      </Link>
    );

    appLink = <Link to={entityRoute(parseEntityRef(stringifyEntityRef(associateAppComponent)))}>
      App
    </Link>;
  }

  if (useUtc && metadata.create_time) {
    metadata.create_time = new Date(metadata.create_time).toISOString();
  } else if (metadata.create_time) {
    metadata.create_time = new Date(metadata.create_time).toLocaleString();
  }

  return (
    <InfoCard title="App" headerProps={{ title: appLink as any, avatar: <AppsIcon /> }} >
      <StructuredMetadataTable metadata={metadata} />
    </InfoCard>
  );
}
